var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-center"},[_c('div',{staticClass:"animated-text",class:{
      active: _vm.started && !_vm.stopped,
      test: _vm.subTitleFont,
      'animated-text-mobile': !_vm.device,
    },domProps:{"textContent":_vm._s(_vm.visibleText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }